import React from 'react';
import { steps } from '../data/content';
export function StepsSection() {
  return <section className="w-full bg-cream py-14 sm:py-16 lg:py-20" aria-labelledby="como-funciona" data-id="element-154" data-mp="10m27arro7ln6">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-155" data-mp="1elbo9tnpajs7">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14" data-id="element-156" data-mp="1emv0n968kaop">
          <div data-id="element-157" data-mp="19kxfg9e9z5t4">
            <h2 id="como-funciona" className="font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-ink sm:text-4xl" data-id="element-158" data-mp="19ol876bwbo6s">
              Cómo funciona, semana a semana
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-159" data-mp="1xckunu26csfk">
              Tres pasos que se repiten. La primera vez te lleva un rato; para la tercera semana ya
              te sale solo.
            </p>
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/b0a8ac3b-2d0a-4405-b875-81c4b68d5873.jpg" alt="Bolsas de compras del súper apoyadas en la mesada de una cocina" className="mt-8 hidden aspect-[3/2] w-full rounded-2xl object-cover shadow-card lg:block" loading="lazy" data-id="element-160" data-mp="27bag1wta4v0k" />
          </div>

          <ol className="relative space-y-4" data-id="element-161" data-mp="2ml5u2wt984nx">
            {steps.map(step => <li key={step.number} className="flex gap-4 rounded-2xl border border-ink/10 bg-white p-5 shadow-card sm:gap-5 sm:p-6" data-id="element-162" data-mp="2qnah3cp7631l">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-verde font-display text-lg font-bold text-white" aria-hidden="true" data-id="element-163" data-mp="2vkj3xqlaiv96">
                  {step.number}
                </span>
                <div data-id="element-164" data-mp="3aaglhnopsmpe">
                  <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-165" data-mp="3ad2qpgo4uq4g">
                    <h3 className="font-display text-xl font-bold uppercase tracking-tight text-ink sm:text-2xl" data-id="element-166" data-mp="3eeo9tjr9g0n3">
                      {step.title}
                    </h3>
                    <span className="font-mono text-[11px] uppercase tracking-widest text-naranja" data-id="element-167" data-mp="1jahxyia8h9cr">
                      {step.meta}
                    </span>
                  </div>
                  <p className="mt-2 text-[15px] leading-relaxed text-ink-soft sm:text-base" data-id="element-168" data-mp="1szrtk84ada5m">
                    {step.text}
                  </p>
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}